import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MarketService } from '../../../services/market.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NguCarousel, NguCarouselStore } from '@ngu/carousel';
import { MarketInfo } from '../../../models/MarketInfo';
import { MarketOffer } from '../../../models/MarketOffer';
import { NguButton } from '@ngu/carousel/src/ngu-carousel/ngu-carousel.interface';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalComponent } from './../../../shared-components/modal/modal.component';
import { EmailService } from '../../../services/email.service';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { MarketplaceCase } from '../../../models/MarketplaceCase';
import { DataService } from '../../../services/data.service';



@Component({
  selector: 'app-market-place',
  templateUrl: './market-place.component.html',
  styleUrls: ['./market-place.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MarketPlaceComponent implements OnInit, OnDestroy {

  private alive = true;
  public imageData: string;
  public carouselOne: NguCarousel;
  public marketInfo: MarketInfo[];
  public modRef: BsModalRef;
  public emailRef: BsModalRef;
  public radioSelected:string;
  public offerSelected = false;
  public vendor: MarketInfo;
  public offer: MarketOffer;
  public companyName: string;
  public contactFirstName: string;
  public contactLastName: string;
  public phone: string;
  public title: string;
  public template: TemplateRef<any>;
  config = {
    animated: false,
    class: 'market-modal'
  };

  // Carousel Test
  public heros: string[] = [
    'assets/img/hero.jpg',
    /*'assets/img/MYJSSI_MARKETPLACE_HERO_AS.jpg',
    'assets/img/MYJSSI_MARKETPLACE_HERO_AS_v2.jpg'
    'assets/img/MYJSSI_MARKETPLACE_HERO.jpg',
    'assets/img/MYJSSI_MARKETPLACE_JEL.jpg',
    'assets/img/MYJSSI_MARKETPLACE_PARTS.jpg'*/
  ];

  @ViewChild('templateEmail') templateEmail: ModalComponent;
  @ViewChild('templateConfirmation') templateConfirmation: ModalComponent;
  public emailToAddress: string;
  public emailCCAddress: string;
  public emailComments: string;
  public showEmailSuccessConfirmation = false;
  public showEmailFailConfirmation = false;
  public emailSentFailMessage = '';
  public docNumberToSendEmail: string;

  constructor(private marketService: MarketService,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private emailSvc: EmailService,
    public _DomSanitizationService: DomSanitizer) { }



  ngOnInit() {
    this.spinner.show();
    this.carouselOne = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 10000,
      point: {
        visible: true,
        pointStyles: `
        .ngucarouselPoint {
          list-style-type: none;
          text-align: center;
          padding: 12px;
          margin: 0;
          white-space: nowrap;
          overflow: auto;
          position: absolute;
          width: 100%;
          bottom: 20px;
          left: 0;
          box-sizing: border-box;
        }
        .ngucarouselPoint li {
          display: inline-block;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.55);
          padding: 5px;
          margin: 0 3px;
          transition: .4s ease all;
        }
        .ngucarouselPoint li.active {
            background: white;
            width: 10px;
        }
      `
      },
      load: 2,
      loop: true,
      touch: false
    };

    this.marketService.getMarketInfo()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log('market info: ', data);
          this.marketInfo = data;
          // console.log('abc..', this.marketInfo[0].LogoImage);
          this.imageData = this.marketInfo[0].LogoImage;
          this.spinner.hide();
        },
        err => {
          console.log('Search test, ', err);
          this.spinner.hide();
        }
      );
  }

  showVendorDetails(template: TemplateRef<any>, vendor: MarketInfo) {
    console.log('show details');
    this.resetInfo();

    this.vendor = vendor;
    this.template = template;
    this.modRef = this.modalService.show(template, this.config);

    // Default to select the first offer
    if (this.radioSelected === null && vendor.Offers !== null) {
      this.offer = vendor.Offers[0];
      this.radioSelected = vendor.Offers[0].OfferNumber;
      this.offerSelected = true;
    }

  }

  resetInfo() {
    this.vendor = null;
    this.offer = null;
    this.offerSelected = false;
    this.radioSelected = null;
    this.companyName = null;
    this.contactFirstName = null;
    this.contactLastName = null;
    this.phone = null;
    this.title = null;
    this.emailToAddress = null;
    this.emailCCAddress = null;
  }

  closeVendorDetails() {
    this.modRef.hide();
    //   this.resetInfo();
  }


  closeSendEmail() {
    this.emailRef.hide();
    this.modRef = this.modalService.show(this.template, this.config);
  }

  closeAll() {
    this.emailRef.hide();
    this.modRef.hide();
    //    this.resetInfo();
  }

  onmoveFn(data: NguCarouselStore) {
    console.log(data);
  }

  marketInfoFilter(type: string) {
    console.log('just for test....', type);
  }


  showEmailModal(template: TemplateRef<any>) {
    this.contactFirstName = this.dataService.userDisplayInfo.FirstName;
    this.contactLastName = this.dataService.userDisplayInfo.LastName;
    this.emailToAddress = this.dataService.userDisplayInfo.Email;
    this.emailCCAddress = this.dataService.userDisplayInfo.Email;
    this.modRef.hide();
    this.emailRef = this.modalService.show(template, this.config);

    this.modRef.hide();

  }

  sendEmail() {
    this.spinner.show();
    // this.closeSendEmail();
    const caseInfo: MarketplaceCase = new MarketplaceCase();
    caseInfo.VendorID = this.vendor.ID;
    caseInfo.OfferID = this.offer.ID;
    caseInfo.Email = this.emailToAddress;
    caseInfo.CompanyName = this.companyName;
    caseInfo.Phone = this.phone;
    caseInfo.Title = this.title;
    caseInfo.Name = this.contactFirstName + ' ' + this.contactLastName;
    caseInfo.MyJSSIUserName = this.dataService.userDisplayInfo.LoginID;
    caseInfo.Comments = null;
    this.closeAll();
    this.marketService.saveMarketplaceCase(caseInfo)
      .takeWhile(() => this.alive)
      .subscribe(data => {

        console.log(data);

        this.spinner.hide();
        this.showEmailSuccessConfirmation = true;
        this.showEmailFailConfirmation = false;

        this.templateConfirmation.show();
      }, err => {
        this.spinner.hide();
        console.log('save marketplace failed.', err);

        this.showEmailSuccessConfirmation = false;
        this.showEmailFailConfirmation = true;
        this.emailSentFailMessage = err._body;

        this.templateConfirmation.show();
      }
      );

  }

  getRemaining(emailComments: string, maximum: number): string {
    return `${emailComments ? maximum - emailComments.length : maximum} characters remaining`;
  }

  ngOnDestroy() {
    this.alive = false;
  }

  selectOffer(offer: MarketOffer) {
    this.offerSelected = true;
    this.offer = offer;
  }

  reduceVendorDesc(desc: string): string {
    if (desc.length > 300) {
      const reducedDesc: string = desc.substring(0, 296) + '...';
      return reducedDesc;
    } else {
      return desc;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/client/market-place/market-place.component.ts